import {
    type FC
} from "react";
import type IDataTableRowActionsProps from "./type";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    NCoreUIKitIcon
} from "../../../../types";
import {
    useDataTableContext
} from "../../context";
import {
    Ellipsis as EllipsisIcon
} from "lucide-react-native";
import DropdownMenu from "../../../dropdownMenu";
import Button from "../../../button";

const DataTableRowActions: FC<IDataTableRowActionsProps> = ({
    customTheme: customThemeProp,
    side = "bottom",
    align = "end",
    children,
    title
}) => {
    const context = useDataTableContext({
        part: "RowActions"
    });

    const {
        colors
    } = NCoreUIKitTheme.useContext(customThemeProp ?? context?.customTheme);

    const {
        localize
    } = NCoreUIKitLocalize.useContext(context?.customLocalize);

    if(!context) {
        return null;
    }

    const currentTheme = customThemeProp ?? context.customTheme;

    const renderIcon: NCoreUIKitIcon = ({
        customColor,
        color,
        size
    }) => <EllipsisIcon
        color={customColor ?? colors.content.icon[color]}
        size={size}
    />;

    return <DropdownMenu
        customLocalize={context.customLocalize}
        customTheme={currentTheme}
        align={align}
        side={side}
    >
        <DropdownMenu.Trigger>
            <Button
                aria-label={title ?? localize("more-actions")}
                customTheme={currentTheme}
                onPress={() => undefined}
                icon={renderIcon}
                variant="ghost"
                type="neutral"
                size="small"
            />
        </DropdownMenu.Trigger>
        <DropdownMenu.Content>
            {children}
        </DropdownMenu.Content>
    </DropdownMenu>;
};
export default DataTableRowActions;
